export type DateUnitOptions =
  | 'second'
  | 'seconds'
  | 'minute'
  | 'minutes'
  | 'hour'
  | 'hours'
  | 'day'
  | 'days'
  | 'date'
  | 'month'
  | 'months'
  | 'year'
  | 'years'

function getDateDiff(
  endDate: Date,
  startDate: Date,
  unit: DateUnitOptions,
): number {
  const diffInMs = endDate.getTime() - startDate.getTime()

  switch (unit) {
    case 'second':
    case 'seconds':
      return Math.floor(diffInMs / 1000)

    case 'minute':
    case 'minutes':
      return Math.floor(diffInMs / (1000 * 60))

    case 'hour':
    case 'hours':
      return Math.floor(diffInMs / (1000 * 60 * 60))

    case 'day':
    case 'days':
    case 'date':
      return Math.floor(diffInMs / (1000 * 60 * 60 * 24))

    case 'month':
    case 'months':
      const yearDiff = endDate.getFullYear() - startDate.getFullYear()
      const monthDiff = endDate.getMonth() - startDate.getMonth()
      let totalMonths = yearDiff * 12 + monthDiff

      // Ajuste para casos onde o dia do mês final é menor que o inicial
      if (endDate.getDate() < startDate.getDate()) {
        totalMonths--
      }

      return totalMonths

    case 'year':
    case 'years':
      let yearsDiff = endDate.getFullYear() - startDate.getFullYear()

      // Ajuste para casos onde ainda não chegou no aniversário
      const monthDiffYear = endDate.getMonth() - startDate.getMonth()
      const dayDiff = endDate.getDate() - startDate.getDate()

      if (monthDiffYear < 0 || (monthDiffYear === 0 && dayDiff < 0)) {
        yearsDiff--
      }

      return yearsDiff

    default:
      throw new Error(`Unidade não suportada: ${unit}`)
  }
}

// Exemplo de uso:
export const date = {
  getDateDiff,
}
